import { render, staticRenderFns } from "./Vue100vh.vue?vue&type=template&id=2f60f4c7&lang=pug&"
import script from "./Vue100vh.vue?vue&type=script&lang=js&"
export * from "./Vue100vh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f60f4c7')) {
      api.createRecord('2f60f4c7', component.options)
    } else {
      api.reload('2f60f4c7', component.options)
    }
    module.hot.accept("./Vue100vh.vue?vue&type=template&id=2f60f4c7&lang=pug&", function () {
      api.rerender('2f60f4c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/basic/Vue100vh.vue"
export default component.exports